/* eslint-disable */

import { axiosWaTemplate, axiosExternal, axiosNewWATemplate } from "config/axios.config";
import authSvc from "services/authSvc";

const currentUser = authSvc.currentUser();

const waTemplateSvc = {
  getListTemplate: async (data) => {
    let dataStatus = data.status.length > 0 ? data.status.join() : 'all';

    // const response = await axiosWaTemplate.get(`${'request/wa/template'}/${currentUser?.user?.id}/10/1/all`, params, 
    const response = await axiosWaTemplate.get(`${'request/wa/template'}/${data.application_id[0]}/${data.limit}/${data.page}/${dataStatus}?search=${data.search}&startDate=${data.start_date}&endDate=${data.end_date}`);
    return response;
  },
  duplicateTemplate: async (templateId, request) => {
    const response = await axiosWaTemplate.put(`${'request/wa/template/duplicate'}/${templateId}`, request);
    return response;
  },
  deleteTemplate: async (templateId) => {
    const response = await axiosWaTemplate.delete(`${'request/wa/template'}/${templateId}`);
    return response;
  },
  deleteTemplateBulk: async (request) => {
    const response = await axiosWaTemplate.post(`${'request/wa/delete/template/bulk'}`, request);
    return response;
  },
  updateDraftTemplate: async (data, request) => {
    let draft = false;
    if (data.status === 'draft') {
      draft = true;
    }
    const response = await axiosWaTemplate.put(`${'request/wa/template/'}${data.template_id}?draft=${draft}`, request);
    return response;
  },
  createDraftTemplate: async (status, request) => {
    let draft = '';
    if (status == 'draft') {
      draft = status;
    }
    const response = await axiosWaTemplate.post(`${'request/wa/template/'}${draft}`, request);
    return response;
  },
  getDetailTemplate: async (templateId) => {
    const response = await axiosWaTemplate.get(`${'request/wa/template'}/${templateId}`);
    return response;
  },
  getTemplateName: async (template_name, appId) => {
    const response = await axiosWaTemplate.get(`${'request/wa/template/check'}/${appId}/${template_name}`);
    return response;
  },
  getTemplateMedia: async (data) => {
    const response = await axiosWaTemplate.get(`${'whatsapp/template-info/'}${data}`);
    return response;
  },
  getVariableList: async (appId) => {
    const response = await axiosWaTemplate.get(`${'variables/'}${appId}`);
    return response;
  },
  getMaskingWa: async (appId) => {
    const response = await axiosExternal.get(`${'user/settings/channel'}`, {
      headers: {
        "content-type": "application/json",
        "apiKey": "V4py8Wv7P1MWPS",
        "x-key-id": appId
      }
    });
    return response;
  },
  listWABA: async (userId) => {
    const response = await axiosNewWATemplate.get(`${'waba'}/${userId}`);
    // const response = await axiosNewWATemplate.get(`${'waba'}/61ee708875682700297df40a`);
    return response;
  },
  listWhatsappTemplateById: async (wabaID, requestBody) => {
    const response = await axiosNewWATemplate.post(`${'list-template'}/${wabaID}`, requestBody);
    return response;
  },
  createWhatsappTemplate: async (wabaID, requestBody) => {
    const response = await axiosNewWATemplate.post(`${'template'}/${wabaID}`, requestBody);
    return response;
  },
  deleteWhatsappTemplate: async (wabaID, templateID) => {
    const response = await axiosNewWATemplate.delete(`${'template'}/${wabaID}/${templateID}`);
    return response;
  },
  editWhatsappTemplate: async (wabaID, templateID, requestBody) => {
    const response = await axiosNewWATemplate.put(`${'template'}/${wabaID}/${templateID}`, requestBody);
    return response;
  },
  validateTemplateName: async (wabaID, requestParams) => {
    const response = await axiosNewWATemplate.get(`${'template'}/${wabaID}?template_name=${requestParams}`);
    return response;
  },
  uploadPictureProfile: async (body, type) => {
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://staging-wabacloud.ocaindonesia.co.id/api/v1/upload-profile',
      headers: { 
        'Content-Type': type
      },
      data : body
    };
    console.log('response sss',body,config)
    const response = await axios(config);
    console.log('response sss', response,body,config)
    return response;
    // const response = await axiosManageChannel.post(`${'upload-profile'}`, body,{
    //   headers: {
    //     'Content-Type': type
    //   },
    // })
    // console.log('response sss', response,body)
    // return response;
  },
  updateNEWWATemplate: async (template_id, request) => {
    const response = await axiosWaTemplate.put(`${'/wa-template/request-bsp/'}${template_id}`, request);
    return response;
  },
  createNEWWATemplate: async (request) => {
    const response = await axiosWaTemplate.post(`${'/wa-template/request-bsp'}`, request);
    return response;
  },
  
  updateTemplate: async (data, request) => {
    let draft = false;
    if (data.status === 'draft') {
      draft = true;
    }
    const params = {};
    params["draft"] = draft;
    const response = await axiosWaTemplate.put(`${'request/wa/template/'}${data.template_id}?draft=${draft}`, request);
    return response;
  },
  createTemplate: async (status, request) => {
    let draft = '';
    if (status == 'draft') {
      draft = status;
    }
    const response = await axiosWaTemplate.post(`${'request/wa/template/'}${draft}`, request);
    return response;
  },
}

export default waTemplateSvc;